export default __webpack_public_path__ + "assets/png/f064a9ec4f42666ce26578018bbc0c01.png";